<template>
  <div class="or_box">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <!-- <div class="dateSelect" style="margin-left:30px">
          <div class="eventSelectNav">
            <div class="eventType" v-for="(event,index) in list" :key="index" v-bind:class="{selected:isActive==index}" @click="checkItem(event,index)">{{event.name}}</div>
          </div>
        </div> -->
      </div>
      <div class="top-right">
        <!-- <el-button type="text" @click="dropDownScreen">
          <img style="margin-right:20px" src="../../assets/employee/images/screen.png" />
        </el-button> -->
        <el-button type="text" @click="dropDownScreen" style="margin-right:20px">
          <img src="./../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div  class="inputs">
          <!-- <div class="formScreenInput" v-if="isActive==0">
            <div>项目名称</div>
            <el-input size="small" v-model="infoQuery.strobjname" placeholder="请输入项目名称"></el-input>
          </div> -->
          <div class="formScreenInput" v-if="isActive!=0">
            <div>项目名称</div>
            <el-input size="small" v-model="expQuery.custname" placeholder="请输入项目名称"></el-input>
          </div>
          <div class="timeip formScreenInput">
            <div>归属月份</div>
            <el-date-picker v-model="infoQuery.belongMonth" size="small" value-format="yyyy-MM" type="month" placeholder=""></el-date-picker>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>
    </div>
    <importRecord v-if="showPage==0" ref="importRecord"></importRecord>
    <exportRecord v-else :custname="custname" :qStstus="qStstus" ref="exportRecord"></exportRecord>
  </div>
</template>

<script>
import xz from "../../common";
import importRecord from "./components/importRecord";
// import exportRecord from "./components/exportRecord";
export default {
  components: {
    importRecord,
    // exportRecord
  },
  name: "supplyLog",
  data() {
    return {
      //文件是否已上传
      isFileSuccess: false,
      custname: "",
      //根据qStstus值查看导出列表还是最后一条导出记录
      qStstus: "",
      opType: "import",
      isActive: 0,
      list: [
        {
          name: "导入记录",
          value: "import"
        },
        {
          name: "导出记录",
          value: "export"
        }
      ],
      showPage: 0,
      select: "",
      ss: "",
      //下拉筛选
      showDropScreen: -1,
      //服务中心
      strsrvcent: '',
      //业务立项部门
      strobjinstname: '',
      //项目名称
      objname: '',
      //负责客服
      strusername: '',
      //时间范围
      impdate: [],
      //开始时间
      startDate: '',
      //结束时间
      endDate: '',
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        belongMonth: '',
        tableid: "JB_busi_UtilityBill"
      },
      expQuery: {
        pagecount: 10,
        currpage: 1,
        tableid: "XZ_emp_UserBase,XZ_emp_UserBasenewout",
        custname: "",
        datestart: "",
        dateend: '',
        impdate: ''
      }
    };
  },
  created() {
    if (window.localStorage.getItem('page')) {
      this.infoQuery.pagecount = window.localStorage.getItem('page');
    }
    let q = this.$route.query;
    // console.log('q',q)
    if (q.isActive) {
      this.showPage = 1
      this.isActive = q.isActive;
      this.showPage = q.showPage;
      this.custname = q.custname;
      this.qStstus = q.qStstus;
    }
    this.getServiceList()
    this.getApartmentList()
  },
  methods: {
    //搜索
    searchHandle() {
      if (this.infoQuery.impdate === undefined || this.infoQuery.impdate === null) {
        this.infoQuery.impdate = [];
        this.infoQuery.datestart = '';
        this.infoQuery.dateend = '';
        this.expQuery.impdate = [];
        this.expQuery.datestart = '';
        this.expQuery.dateend = ''
      }
      if (this.infoQuery.impdate.length > 0) {
        this.infoQuery.datestart = this.infoQuery.impdate[0];
        this.infoQuery.dateend = this.infoQuery.impdate[1];
        this.expQuery.impdate = this.infoQuery.impdate;
        this.expQuery.datestart = this.infoQuery.impdate[0];
        this.expQuery.dateend = this.infoQuery.impdate[1]
      }
      if (this.showPage == 0) {
        // console.log('infoQuery',this.infoQuery)
        this.infoQuery.currpage = 1;
        this.$refs.importRecord.getOpeRecord(this.infoQuery);
      } else {
        // console.log('exportRecord',this.infoQuery)
        this.expQuery.currpage = 1;
        this.$refs.exportRecord.getExportRecord(this.expQuery);
      }
      this.showDropScreen = -1
    },
    //清空
    resetHandle() {
      this.infoQuery = {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_UserBase",
        instname: "",
        impdatestart: "",
        impdateend: "",
        objname: "",
        strobjinstname: "",
        strusername: "",
        impdate: ''
      };
      this.expQuery = {
        pagecount: 10,
        currpage: 1,
        tableid: "XZ_emp_UserBase",
        custname: "",
        datestart: "",
        dateend: ''
      }
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then(res => {
        // console.log("getServeList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname })
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    serviceChange() {
      this.getApartmentList(this.infoQuery.strsrvcent, '')
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then(res => {
        // console.log("getApartmentList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName })
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    },
    //切换
    checkItem(event, index) {
      this.isActive = index;
      this.opType = event.value;
      (this.opType == "import") ? (this.showPage = 0) : (this.showPage = 1);
    },
  },
};
</script>


<style scoped>
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>
<style >
.or_box .el-table .el-table__cell{
  padding: 6px 0;
}
.timeip .el-date-editor .el-range-separator {
  line-height: 24px;
}
.operationRecordTable .el-table td {
  padding: 5px 0;
}
.operationRecordTable .el-table th {
  padding: 10px 0;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.timeip .el-input__icon {
  margin-top: 3px !important;
  height: 32px;
  line-height: 32px;
}
.timeip .el-date-editor .el-range__icon {
  margin-top: 0px !important;
}
</style>